/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Body2Inputs */

const en_minifier_body2 = /** @type {(inputs: Minifier_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The size counter is the reason to use a minifier interactively rather than in a build step: it tells you whether the saving is worth anything for your particular payload. Deeply nested documents with short values benefit the most, because indentation is a large fraction of their bytes. Flat documents with long string values barely change at all.`)
};

const ko_minifier_body2 = /** @type {(inputs: Minifier_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기 표시가 있기 때문에 빌드 단계가 아니라 대화형으로 압축기를 쓸 이유가 생깁니다. 내 페이로드에서 이 절감이 값어치가 있는지 알려주기 때문입니다. 값이 짧고 깊게 중첩된 문서가 가장 큰 이득을 봅니다. 들여쓰기가 바이트의 큰 몫을 차지하기 때문입니다. 문자열 값이 긴 평평한 문서는 거의 변하지 않습니다.`)
};

const ja_minifier_body2 = /** @type {(inputs: Minifier_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ表示があるからこそ、ビルド段階ではなく対話的に圧縮ツールを使う意味があります。自分のペイロードでその削減に価値があるかを教えてくれるからです。値が短く深くネストした文書が最も得をします。インデントがバイトの大きな割合を占めるからです。文字列値が長い平坦な文書はほとんど変わりません。`)
};

/**
* | output |
* | --- |
* | "The size counter is the reason to use a minifier interactively rather than in a build step: it tells you whether the saving is worth anything for your partic..." |
*
* @param {Minifier_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_body2 = /** @type {((inputs?: Minifier_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_body2(inputs)
	if (locale === "ko") return ko_minifier_body2(inputs)
	return ja_minifier_body2(inputs)
});